import { Typography } from '@mui/material';
import type { ColorPickerFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { Box, Image } from '@packages/shared';
import type { FC } from 'react';

type Value = ColorPickerFragmentFragment['dimensions'][number]['values'][number];

export interface ImageGalleryColorDialogItemProps {
  /**
   * The dimension value to display.
   */
  value: Value;

  /**
   * Select handler. Call when the variation has been selected (clicked)
   *
   * @param value Dimension value.
   */
  onSelect(value: Value): void;
}

export const ImageGalleryColorDialogItem: FC<ImageGalleryColorDialogItemProps> = ({
  value,
  onSelect,
}) => (
  <Box
    data-testid="imagegallery-color-item"
    onClick={() => onSelect(value)}
    sx={{
      minWidth: '6rem',
      width: '6rem',
      borderRadius: '3px',
      boxShadow: 1,
      backgroundColor: 'text.light',
      borderWidth: '2px',
      borderStyle: value.isSelected! ? 'solid' : 'none',
      borderColor: 'text.dark',
      overflow: 'hidden',
      // the horziontal scroll component will cut off the box shadow otherwise, this is most likely to the 'contain' scroll-behavior
      margin: '1px',
    }}
  >
    <Box
      sx={{
        width: '6rem',
        height: '6rem',
        position: 'relative',
        '> img': {
          maxHeight: 'auto',
          maxWidth: 'auto',
          objectFit: 'contain',
        },
      }}
    >
      {value.variationMainImage ? (
        /* TODO: where do we get an alt text from? */
        <Image fill src={`${value.variationMainImage!}?$PDV_gallery$`} alt="" />
      ) : (
        value.rgb && (
          <Box
            title={value.displayText!}
            sx={{
              backgroundColor: `#${value.rgb}`,
              height: '100%',
              width: '100%',
            }}
          />
        )
      )}
    </Box>
    <Box
      textAlign="center"
      sx={{
        py: 1.5,
      }}
    >
      <Typography variant="body3">{value.displayText}</Typography>
    </Box>
  </Box>
);
